import { ArrowBackIos, ContentCopy, FileDownload } from '@mui/icons-material';
import React, { useEffect } from 'react';
import { DataTable } from 'primereact/datatable';
import { Column } from 'primereact/column';
import { useLocation, useNavigate } from 'react-router-dom';
import { IconButton, Tooltip } from '@mui/material';
import { toast } from 'react-toastify';
import { Header } from '../../components/header/header';
import {
  ContainerStyled,
  ContainerTable
} from '../../components/layout/main/mainStyles';
import Strings from '../../i18n';
import { ButtonIconStyled, TitleStyled } from '../devices/devicesStyles';

import { useGetLogsByApplicationMutation } from '../../services/application/applicationService';
import { IApplicationLogItem } from '../../types/applications/ApplicationsInterfaces';
import { utcToBrowserDate } from '../../utils/date';

export const ApplicationsLogsView = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const queryParams = new URLSearchParams(location.search);
  const userId = queryParams.get('userId');
  const { userId: userIdFromState, userName } = location.state || {};
  const [
    getLogsByApplication,
    { data, isSuccess: successGetApplicationsLogs }
  ] = useGetLogsByApplicationMutation();

  useEffect(() => {
    if (userIdFromState || userId) {
      getLogsByApplication(Number(userIdFromState || Number(userId)));
    } else {
      getLogsByApplication();
    }
  }, []);

  const getDownloadUrl = (rowData: IApplicationLogItem) => {
    return (
      <>
        <Tooltip title={Strings.common.copyUrl} placement="top" arrow>
          <IconButton
            size="small"
            onClick={() => {
              navigator.clipboard.writeText(rowData.url);
              toast.success(Strings.common.copiedText);
            }}
          >
            <ContentCopy fontSize="small" />
          </IconButton>
        </Tooltip>
        <a href={rowData.url} target="_blank" rel="noopener noreferrer">
          <FileDownload fontSize="small" className="no-decoration" /> Download
        </a>
      </>
    );
  };
  const getDateFormat = (rowData: IApplicationLogItem) => {
    return utcToBrowserDate(rowData.createdAt);
  };

  return (
    <>
      <Header>
        <ContainerStyled>
          <div className="row justify-content-between">
            <div className="col-4 text-left">
              <ButtonIconStyled size="small" onClick={() => navigate(-1)}>
                <ArrowBackIos />
              </ButtonIconStyled>
            </div>
            <div className="col-4 text-center">
              <TitleStyled>
                {Strings.applicationsLogs.applicationsLogs}
                {userName && ` - ${userName}`}
              </TitleStyled>
            </div>
            <div className="col-8 col-sm-4 text-right" />
          </div>
        </ContainerStyled>
      </Header>
      <ContainerTable component="main">
        {data && successGetApplicationsLogs && (
          <DataTable
            value={data.applicationLogs}
            size="small"
            scrollable
            scrollHeight="flex"
            selectionPageOnly
            tableStyle={{ fontSize: '14px' }}
          >
            <Column
              field="createdAt"
              header="Date"
              sortable
              body={getDateFormat}
            />
            <Column field="createdByName" header="User Name" sortable />
            <Column field="hardwareInfo" header="Mobile Device" sortable />
            <Column field="osInfo" header="Mobile OS" sortable />
            <Column field="url" header="Url" sortable body={getDownloadUrl} />
          </DataTable>
        )}
      </ContainerTable>
    </>
  );
};
